import { MenuItem } from "@mui/material";
import styled from "styled-components";
import { color } from "../../../styles";

interface ItemTypeTagProps {
  itemType: 'product' | 'material';
}

export const ItemTypeTag = styled.span<ItemTypeTagProps>`
  margin-left: 8px;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  background-color: ${props => props.itemType === 'product' ? color.primary.BLUE_B100 : color.status.WARNING};
  color: white;
  white-space: nowrap;
`;

export const CustomMenuItem = styled(MenuItem)`
  && {
    &:hover {
      background: none;
      color: ${color.primary.BLUE_B100};
      
      span {
        color: inherit;
      }
      
      ${ItemTypeTag} {
        color: white !important;
      }
    }
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 6px;
    padding: 4px 8px;
    display: flex;
    min-height: 32px;
    gap: 8px;
    align-items: center;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const Anchor = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  box-sizing: border-box;
  background-color: white;
  margin-top: 8px;
  padding-left: 12px;
  padding-right: 12px;
  border: 1px solid ${color.secondary.GREY_4};
  border-radius: 5px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 1600;
`;
